import {Navigate} from "react-router-dom";
import {Layout} from "../components/Layout";
import {PlansPage} from "../pages/PlansPage";
import {ActionsPage} from "../pages/ActionsPage";
import {PurchasesPage} from "../pages/PurchasesPage";
import {PurchaseDetailPage} from "../pages/PurchaseDetailPage";
import {OzonHomePage} from "../pages/ozon/OzonHomePage";
import {ProductPage} from "../pages/ozon/product-page/product-page";
import {ProductOverviewPage} from "../pages/ozon/product-page/overview-page";
import {ProductUnitPage} from "../pages/ozon/product-page/analytics-unit-page";
import {ProductSalesPage} from "../pages/ozon/product-page/analytics-sales-page";
import {ProductStocksPage} from "../pages/ozon/product-page/analytics-stocks-page";
import {ProductRunsPage} from "../pages/ozon/product-page/analytics-runs-page";
import {CompetitorsSummaryPage} from "../pages/ozon/product-page/competitors-summary-page";
import {CompetitorsComparisonPage} from "../pages/ozon/product-page/competitors-comparison-page";
import {CompetitorsManagePage} from "../pages/ozon/product-page/competitors-tab";
import {ProductsPage} from "../pages/ozon/products-page/products-page";
import {StocksPage} from "../pages/ozon/stocks-page/stocks-page";
import {StoreEconomicsPage} from "../pages/ozon/store-economics-page/store-economics-page";
import {SalesDynamicsPage} from "../pages/ozon/sales-dynamics-page/sales-dynamics-page";
import {SettingsAccessPage} from "../pages/settings/access/access-page";
import {SettingsAnalysisHubPage} from "../pages/settings/analysis/analysis-page";
import {SettingsAnalysisPage} from "../pages/settings/analysis/thresholds-page";
import {SettingsProductAnalysisPage} from "../pages/settings/analysis/product-page";
import {SettingsAppearancePage} from "../pages/settings/appearance/appearance-page";
import {SettingsDebugHubPage} from "../pages/settings/debug/debug-page";
import {SettingsDebugPerformancePage} from "../pages/settings/debug/performance-page";
import {SettingsDebugSchedulerPage} from "../pages/settings/debug/scheduler-page";
import {SettingsDebugManualPage} from "../pages/settings/debug/manual-page";
import {SettingsDevelopmentPage} from "../pages/settings/development/development-page";
import {SettingsAnalyzerLogsPage} from "../pages/settings/development/analyzer-logs-page";
import {SettingsHomePage} from "../pages/settings/home-page";
import {SettingsPeriodsPage} from "../pages/settings/periods/periods-page";
import {SettingsIntegrationsPage} from "../pages/settings/integrations/integrations-page";
import {SettingsOzonDataPage} from "../pages/settings/integrations/ozon-data-page";
import {SettingsOzonFinancePage} from "../pages/settings/integrations/ozon-finance-page";
import {SettingsOzonPage} from "../pages/settings/access/ozon-page";
import {SettingsSellmonitorPage} from "../pages/settings/access/sellmonitor-page";
import {SettingsAiPage} from "../pages/settings/access/ai-page";
import {SettingsPromptsPage} from "../pages/settings/access/prompts-page";
import {AnalysesHomePage} from "../pages/analyses/AnalysesHomePage";
import {DigestPage} from "../pages/analyses/DigestPage";
import {SkuAnalysisDetailPage} from "../pages/analyses/SkuAnalysisDetailPage";
import {SkuAnalysisListPage} from "../pages/analyses/SkuAnalysisListPage";
import {SkuAnalysisRunPage} from "../pages/analyses/SkuAnalysisRunPage";
import {NotFoundPage} from "../pages/not-found-page";
import type {AppRouteObject} from "./types";

export const appRoutes: AppRouteObject[] = [
	{
		element: <Layout/>,
		children: [
			{index: true, element: <Navigate to="/plans" replace/>},
			{path: "/plans", element: <PlansPage/>, handle: {breadcrumb: "Планы"}},
			{path: "/actions", element: <ActionsPage/>, handle: {breadcrumb: "Действия"}},
			{path: "/purchases", element: <PurchasesPage/>, handle: {breadcrumb: "Закупки"}},
			{
				path: "/purchases/:purchaseId",
				element: <PurchaseDetailPage/>,
				handle: {breadcrumb: (params) => params.purchaseId?.slice(0, 8) ?? "Закупка"},
			},
			{path: "/ozon", element: <OzonHomePage/>, handle: {breadcrumb: "Ozon"}},
			{
				path: "/ozon/products",
				element: <ProductsPage/>,
				handle: {breadcrumb: "Товары"},
			},
			{
				path: "/ozon/products/:offerId",
				element: <ProductPage/>,
				handle: {breadcrumb: "Товар"},
				children: [
					{index: true, element: <ProductOverviewPage/>},
					{path: "analytics", element: <Navigate to="unit" replace/>},
					{path: "analytics/unit", element: <ProductUnitPage/>},
					{path: "analytics/sales", element: <ProductSalesPage/>},
					{path: "analytics/stocks", element: <ProductStocksPage/>},
					{path: "analytics/runs", element: <ProductRunsPage/>},
					{path: "competitors", element: <CompetitorsSummaryPage/>},
					{path: "competitors/comparison", element: <CompetitorsComparisonPage/>},
					{
						path: "competitors/manage",
						element: <CompetitorsManagePage/>,
					},
				],
			},
			{
				path: "/ozon/stocks",
				element: <StocksPage/>,
				handle: {breadcrumb: "Остатки"},
			},
			{
				path: "/ozon/store-economics",
				element: <StoreEconomicsPage/>,
				handle: {breadcrumb: "Экономика магазина"},
			},
			{
				path: "/ozon/unit-economics",
				element: <Navigate to="/ozon/store-economics" replace/>,
			},
			{
				path: "/ozon/dynamic",
				element: <SalesDynamicsPage/>,
				handle: {breadcrumb: "Динамика продаж"},
			},
			{path: "/analyses", element: <AnalysesHomePage/>, handle: {breadcrumb: "Анализы"}},
			{
				path: "/analyses/digest",
				element: <DigestPage/>,
				handle: {breadcrumb: "Дайджест"},
			},
			{
				path: "/analyses/sku",
				element: <SkuAnalysisListPage/>,
				handle: {breadcrumb: "Анализ SKU"},
			},
			{
				path: "/analyses/sku/:offerId",
				element: <SkuAnalysisDetailPage/>,
				handle: {breadcrumb: (params) => params.offerId ?? "SKU"},
			},
			{
				path: "/analyses/sku/:offerId/runs/:runId",
				element: <SkuAnalysisRunPage/>,
				handle: {breadcrumb: (params) => params.runId ?? "Запуск"},
			},
			{path: "/settings", element: <SettingsHomePage/>, handle: {breadcrumb: "Настройки"}},
			{
				path: "/settings/access",
				element: <SettingsAccessPage/>,
				handle: {breadcrumb: "Доступы"},
			},
			{
				path: "/settings/integrations",
				element: <SettingsIntegrationsPage/>,
				handle: {breadcrumb: "Интеграции"},
			},
			{
				path: "/settings/analysis",
				element: <SettingsAnalysisHubPage/>,
				handle: {breadcrumb: "Настройки анализа"},
			},
			{
				path: "/settings/analysis/thresholds",
				element: <SettingsAnalysisPage/>,
				handle: {breadcrumb: "Пороги и доступ"},
			},
			{
				path: "/settings/appearance",
				element: <SettingsAppearancePage/>,
				handle: {breadcrumb: "Оформление"},
			},
			{
				path: "/settings/periods",
				element: <SettingsPeriodsPage/>,
				handle: {breadcrumb: "Периоды"},
			},
			{
				path: "/settings/development",
				element: <SettingsDevelopmentPage/>,
				handle: {breadcrumb: "Разработка"},
			},
			{path: "/settings/debug", element: <SettingsDebugHubPage/>, handle: {breadcrumb: "Отладка"}},
			{
				path: "/settings/integration/ozon-data",
				element: <SettingsOzonDataPage/>,
				handle: {breadcrumb: "Данные с Ozon"},
			},
			{
				path: "/settings/integration/ozon-data/finance",
				element: <SettingsOzonFinancePage/>,
				handle: {breadcrumb: "Финансовые операции"},
			},
			{path: "/settings/ozon", element: <SettingsOzonPage/>, handle: {breadcrumb: "Ozon"}},
			{
				path: "/settings/sellmonitor",
				element: <SettingsSellmonitorPage/>,
				handle: {breadcrumb: "Sellmonitor"},
			},
			{path: "/settings/ai", element: <SettingsAiPage/>, handle: {breadcrumb: "AI"}},
			{path: "/settings/prompts", element: <SettingsPromptsPage/>, handle: {breadcrumb: "Промпты"}},
			{
				path: "/settings/analyzer-logs",
				element: <SettingsAnalyzerLogsPage/>,
				handle: {breadcrumb: "Логи анализа"},
			},
			{
				path: "/settings/product-analysis",
				element: <SettingsProductAnalysisPage/>,
				handle: {breadcrumb: "Анализ товара"},
			},
			{
				path: "/settings/debug/performance",
				element: <SettingsDebugPerformancePage/>,
				handle: {breadcrumb: "Performance API"},
			},
			{
				path: "/settings/debug/scheduler",
				element: <SettingsDebugSchedulerPage/>,
				handle: {breadcrumb: "Scheduler"},
			},
			{
				path: "/settings/debug/manual",
				element: <SettingsDebugManualPage/>,
				handle: {breadcrumb: "Ручные методы"},
			},
			{
				path: "*",
				element: <NotFoundPage/>,
				handle: {breadcrumb: "Страница не найдена"},
			},
		],
	},
];
